import React from 'react';
import { Badge } from 'snacks-design-system';
interface componentProps {
  children: React.ReactNode;
  title?: string;
  align?: 't-l' | 't-r' | 'b-l' | 'b-r';
  mode?: 'brand' | 'primary' | 'secondary' | 'inverse';
  size?: 'small' | 'medium' | 'large' | 'xlarge';
  aria?: { label: string; labelledby: string };
  dataStrack?: string;
  qaSelector?: string;
}

const PIEBadge = (props: componentProps) => {
  return <Badge {...props} />;
};

export default PIEBadge;
